import { render } from "./SearchMoc.vue?vue&type=template&id=6322b4de&scoped=true"
import script from "./SearchMoc.vue?vue&type=script&lang=js"
export * from "./SearchMoc.vue?vue&type=script&lang=js"

import "./SearchMoc.vue?vue&type=style&index=0&id=6322b4de&scoped=true&lang=css"
import "./SearchMoc.vue?vue&type=style&index=1&id=6322b4de&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6322b4de"]])

export default __exports__